"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FEATURE_FLAGS = void 0;
/**
 * Feature flag keys used across the application (frontend and backend).
 */
exports.FEATURE_FLAGS = {
    // Frontend flags
    SidebarReleaseCard: 'sidebar-release-card',
    CompetitorResearch: 'competitor-research',
    IssuesStatusMessage: 'issues-status-message',
    RecoveringStatusMessage: 'recovering-status-message',
    StatusPageMessage: 'status-page-message',
    Trial: 'has-access-trials',
    ScheduledTasks: 'scheduled-tasks',
    // Gates the "Build Brand Intelligence" extended-onboarding entry.
    BrandIntelligenceOnboarding: 'brand-intelligence-onboarding',
    // Gates the dashboard right-rail card that asks the user to confirm their own Meta ad page.
    // Off by default so the surface rolls out per-org from PostHog. AND-ed with
    // BrandIntelligenceOnboarding: confirming starts a brand-intelligence-mode chat, whose
    // right-rail panel is gated on that flag, so the card must never appear without it.
    DashboardOwnAdvertiserSuggestion: 'dashboard-own-advertiser-suggestion',
    // Gates the Google Ads channel-data & metrics dashboard (KPI cards + Campaigns/Ads
    // insights table). Off by default so Google Ads behaves as it did before the dashboard
    // work landed; Meta's dashboard is unaffected. Enabled per-org from PostHog.
    GoogleAdsDashboard: 'google-ads-dashboard',
    // Early access to in-development Tools pages (e.g. the Naming Convention Generator). Off by
    // default; enabled per-organization from PostHog so new tools can roll out gradually.
    ToolsEarlyAccess: 'tools-early-access',
    // Gates connecting and spending a user's own Higgsfield credits for image generation.
    HiggsfieldCredits: 'higgsfield-credits',
    // Gates the AI-label compliance configuration surfaces (the Compliance tab and the creative
    // preview side panel's Compliance section). OR-ed with superuser rather than replacing it, so
    // staff keep access with the flag off and an organization can be opted in without staff
    // privileges. Visibility only — the compliance endpoints are not gated on it, so a brand's saved
    // settings keep applying if the flag is turned back off.
    AiComplianceLabels: 'ai-compliance-labels',
    // Gates the standalone full-screen onboarding wizard (`/onboarding`) that replaces the in-chat
    // onboarding flow for the users it is enabled for. Off by default and OR-ed with superuser and
    // dev/staging, so the wizard is a hidden trial surface while everyone else keeps the chat flow.
    HiddenOnboardingWizard: 'hidden-onboarding-wizard',
    // Backend flags
    AgentVariant: 'agent-variant',
    // Routes creative-placement REFRAME adaptations through Ideogram's purpose-built ad-resizer
    // instead of the default outpainting engine. Evaluated per acting user (the approver, or the
    // agent's driving user) — a coverage run with no user behind it, such as the reconcile sweep's
    // healing re-dispatch, always uses the default engine. Remix adaptations ignore it entirely.
    // Off by default and fails closed; a terminal Ideogram failure falls back to the default engine
    // within the same run, so enabling it can never leave a placement unproduced.
    IdeogramPlacementResize: 'ideogram-placement-resize',
    // Backend kill-switch / rollout gate for provisioning a manager brand. Checked at the superuser
    // opt-in (brands/empty.ts); when off (or unset), no NEW manager brand can be minted. Existing
    // manager brands are unaffected. Fails closed — a flag lookup error denies provisioning.
    ManagerAccess: 'has-manager-access',
    // Dual-path shadow compare for Insights filters migrating onto filter-core. When on (sampled
    // ~10% via PostHog), the creatives path runs legacy + filter-core row-eval on the same input,
    // returns the legacy result, and logs a capped asymmetric-diff warning on mismatch.
    UnifiedFilterCoreShadow: 'unified-filter-core-shadow',
    // Multivariate: the image model each user's new chats start on unless they pick one (variants and their
    // models in DEFAULT_IMAGE_MODEL_FLAG_VARIANTS). Evaluated per user with the organization as the `company`
    // group; anything but a known variant, or a lookup error, yields GPT Image 2.5 Sunburst.
    DefaultImageModel: 'default-image-model',
    // Shared flags
    NoAgentAccess: 'has-no-agent-access',
    ContextFilesAccess: 'has-context-files-access',
    StudioAccess: 'has_studio_access',
    IntegrationsTikTokAds: 'integrations-tiktok-ads',
};
